'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherPackage } from '@subframe/core';
import type { SaldoPacote } from '../types';
import { formatarDataCurta, formatarPercentual } from '../utils/apuracaoFormatters';
interface ApuracaoBlocoPacoteProps {
  saldo: SaldoPacote;
}
export function ApuracaoBlocoPacote(t0) {
  const $ = _c(33);
  const {
    saldo
  } = t0;
  const percentual = Math.min(100, Math.max(0, saldo.percentualConsumido));
  const acimaDoAlerta = percentual >= saldo.alertaPercentual;
  const restantes = Math.max(0, saldo.total - saldo.consumido);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-brand-50 flex h-10 w-10 items-center justify-center rounded-lg"><FeatherPackage className="text-brand-600 h-5 w-5" /></div>;
    t2 = <h3 className="text-body-bold font-body-bold text-default-font">Saldo do pacote</h3>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== saldo.proximoReset) {
    t3 = formatarDataCurta(saldo.proximoReset);
    $[2] = saldo.proximoReset;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex items-center gap-3">{t1}<div>{t2}<p className="text-caption font-caption text-subtext-color">Reset configurado para {t3}</p></div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== saldo.consumido || $[7] !== saldo.total) {
    t5 = <span className="text-heading-1 font-heading-1 text-default-font">{saldo.consumido} / {saldo.total}</span>;
    $[6] = saldo.consumido;
    $[7] = saldo.total;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `text-body-bold font-body-bold ${acimaDoAlerta ? "text-warning-700" : "text-success-700"}`;
  let t7;
  if ($[9] !== percentual) {
    t7 = formatarPercentual(percentual);
    $[9] = percentual;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <span className={t6}>{t7} consumido</span>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <div className="flex items-baseline justify-between">{t5}{t8}</div>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = `h-full transition-all ${acimaDoAlerta ? "bg-warning-500" : "bg-success-500"}`;
  const t11 = `${percentual}%`;
  let t12;
  if ($[17] !== t11) {
    t12 = {
      width: t11
    };
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t10 || $[20] !== t12) {
    t13 = <div className="h-2 w-full overflow-hidden rounded-full bg-neutral-100"><div className={t10} style={t12} /></div>;
    $[19] = t10;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = restantes === 1 ? "unidade restante" : "unidades restantes";
  let t15;
  if ($[22] !== restantes || $[23] !== saldo.alertaPercentual || $[24] !== t14) {
    t15 = <p className="text-caption font-caption text-subtext-color">{restantes} {t14}{" \xB7 "}Alerta configurado para {saldo.alertaPercentual}%</p>;
    $[22] = restantes;
    $[23] = saldo.alertaPercentual;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15 || $[28] !== t9) {
    t16 = <div className="flex flex-col gap-2">{t9}{t13}{t15}</div>;
    $[26] = t13;
    $[27] = t15;
    $[28] = t9;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16 || $[31] !== t4) {
    t17 = <div className="bg-default-background flex flex-col gap-4 rounded-[16px] border border-solid border-neutral-200 p-6">{t4}{t16}</div>;
    $[30] = t16;
    $[31] = t4;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}